import { render, staticRenderFns } from "./bonusestimate.vue?vue&type=template&id=5ffa8099&scoped=true&"
import script from "./bonusestimate.vue?vue&type=script&lang=ts&"
export * from "./bonusestimate.vue?vue&type=script&lang=ts&"
import style0 from "./bonusestimate.vue?vue&type=style&index=0&id=5ffa8099&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffa8099",
  null
  
)

export default component.exports